import { getBrandCSSClasses } from '../../utils/boxoffice';

const React = require('react');
const ChannelLogo = require('../../../logos/channel-logo');

const ResponsiveImage = require('../../../responsive-images/responsive-image').default;
const TileLink = require('../../common/tile-link');

class PPVTileTemplate extends React.Component {
    renderLogo() {
        const { brand } = this.props;

        if (brand && brand.image && brand.name) {
            return (
                <ChannelLogo src={brand.image} alt={brand.name} usePlaceholder={false} className={getBrandCSSClasses(brand)} />
            );
        }

        return null;
    }

    render() {
        const { url, onClick, tileImage, title, text, startText } = this.props;
        return (
            <TileLink url={url} onClick={onClick}>
                <div className="c-tile__content">
                    <div className="c-tile__media">
                        <ResponsiveImage
                            sources={tileImage}
                            bindResize={true}
                            alt={title}
                            className="c-tile__poster"
                            type="tile"
                        />
                        {this.renderLogo()}
                    </div>
                    <div className="c-tile__body c-tile__caption">
                        <h2 className="c-tile__title u-margin-bottom-tiny qa-ppv-events-tile-title">{title}</h2>
                        {startText && <p className="c-tile__title u-margin-bottom-tiny qa-ppv-events-tile-date">{startText.medium}</p>}
                        <p className="u-fluid__base-size qa-ppv-events-tile-text"><b>{text}</b></p>
                    </div>
                </div>
                <span className="u-hide-visually">- click to open detail panel</span>
            </TileLink>
        );
    }
}

PPVTileTemplate.defaultProps = {
    url: 'https://my.sky.com/orderboxoffice',
    tileImage: {
        small: 'https://www.sky.com/assets2/sky_box_office_ppv_tile.jpg?downsize=640px:*',
        medium: 'https://www.sky.com/assets2/sky_box_office_ppv_tile.jpg?downsize=1024px:*',
        large: 'https://www.sky.com/assets2/sky_box_office_ppv_tile.jpg?downsize=1200px:*'
    }
};

export default PPVTileTemplate;
